module.exports = __webpack_public_path__ + "assets/img/logo.e8e69ea9.svg";